<script lang="ts">
	import type { Snippet } from 'svelte';
	import { resolve, asset } from '$app/paths';

	let { children }: { children: Snippet } = $props();
</script>

<div id="left_side">
	<div id="logo">
		<a href={resolve('/')}>
			<img class="logo_small" src={asset('/img/1024_768/logo.gif')} alt="Логотип компании Woer" />
			<img class="logo_full" src={asset('/img/logo.gif')} alt="Логотип компании Woer" />
		</a>
		<!-- script type="text/javascript">
			/*<![CDATA[*/ if (screen.width == 1024) {
				document.write(
					"<img border='0' src='img/1024_768/logo.gif' alt='Логотип компании Woer' />"
				);
			} else {
				document.write("<img border='0' src='img/logo.gif' alt='Логотип компании Woer' />");
			} /*]]>*/
		</script -->
	</div>
	<div id="off_distrib">
		ЭКСКЛЮЗИВНЫЙ&nbsp;ПРЕДСТАВИТЕЛЬ В&nbsp;РОССИИ - КОМПАНИЯ&nbsp;<strong
			>ООО&laquo;ПРОТОН&raquo;</strong
		>
	</div>
	<div id="menu_catalog">
		<div class="cat_butt">
			<a href={resolve('/cat/8')} style="background-color: #00A9EF"
				>Кабельные муфты и аксессуары холодной усадки
			</a>
		</div>
		<div class="cat_butt">
			<a href={resolve('/cat/6')} style="background-color: #6663EE"
				>Электроизоляционные материалы
			</a>
		</div>
		<div class="cat_butt">
			<a href={resolve('/cat/7')} style="background-color: #9C6EBC"
				>Термоусаживаемые кабельные муфты и аксессуары
			</a>
		</div>
		<div class="cat_butt">
			<a href={resolve('/cat/5')} style="background-color: #EC4545">Термоусаживаемые трубки </a>
		</div>
		<div class="cat_butt">
			<a href={resolve('/cat/9')} style="background-color: #ECB645">Кабельная продукция </a>
		</div>
		<div class="cat_butt">
			<a href={resolve('/cat/10')} style="background-color: #78D748"
				>Технологическое оборудование
			</a>
		</div>

		<div id="left-module">
			<table cellpadding="0" cellspacing="0" class="moduletable">
				<tbody>
					<tr>
						<th valign="top"> Новинки </th>
					</tr>
					<tr>
						<td>
							<a href={resolve('/view/50053')}>
								PVDF - полужесткая тонкостенная термоусаживаемая трубка</a
							><a href={resolve('/page/14')}><br /> </a><a href={resolve('/page/13')}>
								WCST - Трубки холодной усадки</a
							><a href={resolve('/page/14')}
								><br />
								WCSF - Перчатки холодной усадки</a
							><a href={resolve('/cat/17')}
								><strong><br /> </strong>Концевые и соединительные кабельные муфты "Холодной" усадки
								26 / 35 кВ<br />
							</a><a href={resolve('/cat/19')}>
								WCSW / WCSN / WCSJ - Аксессуары для соединительных и концевых муфт "Холодной" усадки<br
								/>
							</a><a href={resolve('/cat/20')}>
								WEB I(K) 10-630 - Высоковольтные разделяемые "Т" образные&#160;коннекторы из
								силикона</a
							><br />
							<a href={resolve('/page/25')}
								>WST-260 - Гибкая силиконовая электроизоляционная трубка</a
							><br />
							<a href={resolve('/cat/13')}
								>WF - Нетермоусаживаемая электроизоляционная трубка из PTFE</a
							><br />
							<a href={resolve('/view/50014')}
								>- Термоусаживаемые концевые кабельные муфты 0,6 / 1.0 кВ</a
							><br />
							<a href={resolve('/view/50042')}
								>- Термоусаживаемые соединительные кабельные муфты 0,6 / 1.0 кВ<br />
							</a><a href={resolve('/view/50045')}
								>- Термоусаживаемые концевые и соединительные кабельные муфты 8.7 / 15.0 кВ</a
							> <br />
							<a href={resolve('/view/10012')}
								>- WRSZT - Термоусаживаемые перчатки для концевых кабельных муфт</a
							><br />
							<a href={resolve('/view/10030')}
								>- WRSFM - Термоусаживаемые колпачки для изоляции и консервационного хранения концов
								кабелей</a
							><br />
							<a href={resolve('/view/10032')}
								>- WRSJD - Термоусаживаемая лента для монтажа кабельных муфт и восстановления
								оболочек высоковольтных кабелей</a
							><br />
							<a href={resolve('/view/10027')}
								>- WRSXP - Термоусаживаемый ремонтный кожух для восстановления повреждённых
								кабельных оболочек</a
							><br />
							<a href={resolve('/view/50041')}>- AC - Термоусаживаемые анодные колпачки</a><br />
							<a href={resolve('/view/50043')}
								>- Антитрекинговые термоусаживаемые изоляционные юбки, предотвращающие эффекты
								трекинга</a
							><br />
							<a href={resolve('/page/24')}
								>W-1-PT - Универсальные подавляющая горение термоусаживаемые трубки со стенками
								нормальной толщины,аналогичная продукция,PAS,PES,DERAY H,DERAY I,F 32,CPX
								55,TCT,CGPT,RNF100, CPX100,SFTW202,WERSAFIT<br />
							</a><a href={resolve('/page/15')}
								>RSFR-135G - Специальные подавляющие горение термоусаживаемые трубки с рабочей
								температурой до +135°C аналогичная продукция,F 32,CGPT,CPX
								55,H,I,CPX100,RNF100,SFTW202,VERSAFIT V2</a
							><br />
							<a href={resolve('/cat/24')}
								>RSFR-HT - Специальные подавляющие горение термоусаживаемые трубки с рабочей
								температурой до +150°С</a
							><br />
							<a href={resolve('/cat/25')}
								>AMS/RSFR - Специальные термоусаживаемые маркеры с нормальными стенками&#160;для
								маркировки проводов</a
							><br />
							<a href={resolve('/page/28')}
								>WOLVO - Специальная термоусаживаемая трубка с нескользящей поверхностью</a
							><br />
							<a href={resolve('/view/50048')}
								>EPDM - Эластомерная термоусаживаемая трубка из этилен-пропилен-диеновой резины</a
							><strong><br /> </strong><a href={resolve('/view/50049')}
								>Флуорэластомер - Термоусаживаемая трубка стойкая к маслам и
								нефтепродуктам,аналогичная
								продукция,V25,VT220,DR25,NTW-H,VITON,CVT600,CDR625,FRAG,NTW-912,VITON-E</a
							><br />
							<p>
								<a href={resolve('/page/17')}
									>W-1-SB (3:1, 4:1) - Тонкостенная термоусаживаемая трубка с клеевым слоем и
									повышенным</a
								> <a href={resolve('/page/17')}>коэффициентом </a><a href={resolve('/page/17')}
									>усадки,аналогичная продукция,IAKT,ATUM,CGAT,CPA100,</a
								>
							</p>
							<p>
								<a href={resolve('/page/17')}>IHKT,HXKT,DWTC,</a>
								<a href={resolve('/page/17')}
									>HTAT,CPA104,ETW,803,ETW 804,SCL,EPTW,MTW 702,W3B2,EPS300</a
								>
							</p>
							<p>
								<a href={resolve('/cat/27')}
									>SBRS GR (4x) - Тонкостенная полужесткая термоусадочная трубка с толстым клеевым
									слоем,аналогичная продукция, Splicemelt, CBK, SPL, CGAT, GSHG, EPS 4000, RBK VWS
									125, ES 2000, SMS, SA2,</a
								> <a href={resolve('/cat/27')}>ES 1000</a>
							</p>
							<a href={resolve('/cat/28')}
								>MSBRS - Среднестенная универсальная подавляющая горение термоусаживаемая трубка с
								клеевым слоем,аналогичная продукция, CFM, MDT-A, MWTM, CCM, CFTW, PMWT, MTW 707</a
							><br />
							<a href={resolve('/cat/29')}
								>HSBRS - Толстостенная универсальная подавляющая горение термоусадочная трубка с
								клеевым слоем,аналогичная продукция, CFW, HDT-A, WCSM, XCSM, PHWT</a
							><br />
							<a href={resolve('/page/29')}
								>GPFS - Специальная термоусаживаемая трубка для защиты топливных и гидравлических
								патрубков</a
							><br />
							<a href={resolve('/page/19')}
								>WMPG - Высоковольтная термоусаживаемая трубка для токоведущих шин
							</a><a href={resolve('/page/19')}>1 кВ, 10 кВ, 35 кВ</a><a href={resolve('/page/19')}
								>, аналогичная продукция, BBIT, CBTM, CBTH, KSF, BBI, BPTM</a
							><br />
							<a href={resolve('/page/11')}
								>WRSJG - Высоковольтная изоляционная термоусаживаемая трубка с антитрекинговыми
								свойствами</a
							><br />
							<a href={resolve('/cat/31')}
								>WRSYL - Термоусаживаемая трубка выравнивающая напряжённость электрического поля
								(ТВНЭП)</a
							><br />
							<a href={resolve('/page/20')}
								>WRSBG - Термоусаживаемая трубка с полупроводниковыми свойствами для формирования
								экранирующего слоя</a
							><br />
							<a href={resolve('/cat/26')}
								>WRSGY - Маслостойкая&#160;термоусаживаемая трубка, для погружения кабелей в
								трансформаторные масла</a
							>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
<div id="right_side">
	<div id="menu_site">
		<ul id="top_menu">
			<table cellpadding="0" cellspacing="0" class="moduletable">
				<tbody>
					<tr>
						<td>
							<ul id="mainlevel">
								<li>
									<a href="/content/view/1/2/" class="mainlevel" id="active_menu">Главная</a>
								</li>
								<li>
									<a href="/content/view/50054/6/" class="mainlevel">О компании</a>
								</li>
								<li><a href={resolve('/cat/1')} class="mainlevel">Карта сайта </a></li>
								<li>
									<a href={resolve('/cat/4')} class="mainlevel">Контактная информация </a>
								</li>
							</ul>
						</td>
					</tr>
				</tbody>
			</table>
		</ul>
	</div>
	<div id="catalog_page">
		{@render children()}

		<div id="copyrights">
			<hr width="100%" align="center" />
			<p>
				Перевод оригинальных текстов - интеллектуальная собственность компании
				&laquo;Протон&raquo;&nbsp;2008&copy;.<br />
				Перепечатывание текстов сайта будет преследоваться в соответствии с законодательством РФ в области
				защиты интеллектуальной собственности.<br />
				Оригинальные тексты и торговая марка &laquo;Woer&raquo; - собственность&nbsp;компании&nbsp;&laquo;Shenzhen&nbsp;Woer&nbsp;Heat-shrinkable&nbsp;Material&nbsp;Co.,Ltd.&raquo;<br
				/>ООО "ПРОТОН" - Эксклюзивный представитель компании WOER на территории РФ
			</p>
		</div>
		<div id="footer">
			<font size="3" face="Monotype Corsiva, Arial"
				><strong>ООО "ПРОТОН" - Эксклюзивный представитель компании WOER на территории РФ</strong
				></font
			><br />&copy;&nbsp;2009 | XHTML1.1 | CSS&nbsp;2.0<br />
			<div id="mettatron">
				<a href="http://www.mettamarket.ru/">Термоусадочная трубка</a>&nbsp;&nbsp;&nbsp;<a
					href="http://www.protonrf.ru/">Термоусаживаемая трубка</a
				>&nbsp;&nbsp;&nbsp;<a href="http://www.mettatron.ru/">Термоусадка</a>
			</div>
		</div>
	</div>
</div>

<style lang="sass">
	.cat_butt
		display: flex
		min-width: 225px
		min-height: 45px
		justify-content: stretch
		box-shadow: 2px 2px 5px  rgba(255,255,255, 0.7)
		margin-bottom: 3px
		a
			width: 100%
			box-sizing: border-box
			display: flex
			justify-content: center
			align-items: center
			text-align: center
			padding: 2px 5px
			font-size: 14px
			color: white

	@media (min-width: 1025px)
		.logo_small
			display: none

	@media (max-width: 1024px)
		.logo_full
			display: none

		.cat_butt
			min-height: 40px
			a
				font-size: 12px




#root
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	position: relative

</style>
